import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="relative overflow-hidden border border-primary bg-collection px-6 py-12 shadow-ravioli-action-lg md:px-10 md:py-16 lg:px-14 lg:py-20">
        <RavioliCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="text-5xl leading-[0.96] md:text-[5rem] md:leading-[4.75rem]"
        />
      </div>
    </RavioliSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
